import { z } from 'zod';
import { DOCUMENT_ID_LENGTH } from '../constants';
import { TitleOwnerVerificationMethod } from '../types';

// CT-3015 step 2 (NOA / superannuation). Added alongside
// verifyTitleOwnerIncomeDocumentsSchema (which stays for the live mutation).
// `verificationMethod` branches the NOA path vs the superannuation-classification
// path. IDMATRIX / NO_INCOME / NONE are not document-verify methods and are
// rejected here.
export const verifyTitleOwnerDocumentsSchema = z.object({
  applicationId: z.string().min(1, 'applicationId is required'),
  titleSearchOwnerId: z.string().min(1, 'titleSearchOwnerId is required'),
  documentIds: z
    .array(z.string().length(DOCUMENT_ID_LENGTH, `Document ID must be ${DOCUMENT_ID_LENGTH} characters long`))
    .min(1, 'At least one document ID is required'),
  verificationMethod: z.enum([TitleOwnerVerificationMethod.NOA, TitleOwnerVerificationMethod.SUPERANNUATION]),
});
